// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__3MLfR","main":"styles_main__1cog2","date_container":"styles_date_container__3PdM7"};